document.addEventListener('DOMContentLoaded',()=>{const t=document.querySelector('[data-menu-toggle]');const n=document.querySelector('[data-nav]');if(t&&n)t.addEventListener('click',()=>{const o=n.classList.toggle('open');t.setAttribute('aria-expanded',String(o));});});
// Sticky's pickup-window selector: displays active windows and attaches pickup
// details to Shopify line item properties. Client-side cutoffs are not secure.
document.addEventListener('DOMContentLoaded', () => {
  const picker = document.querySelector('[data-stickys-pickup]');
  if (!picker) return;
  const form = picker.closest('form');
  const select = picker.querySelector('#stickys-pickup-option');
  const status = picker.querySelector('[data-pickup-status]');
  const addressDisplay = picker.querySelector('[data-pickup-address]');
  const button = form.querySelector('[data-add-to-bag]');
  const fields = {
    drop: picker.querySelector('[data-pickup-drop]'),
    location: picker.querySelector('[data-pickup-location]'),
    address: picker.querySelector('[data-pickup-address-field]'),
    date: picker.querySelector('[data-pickup-date]'),
    window: picker.querySelector('[data-pickup-window]')
  };
  // All weekly schedule calculations use Atlanta local time, including DST.
  const now = new Date();
  const atlantaParts = Object.fromEntries(new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit',
    weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
  }).formatToParts(now).filter(part => part.type !== 'literal').map(part => [part.type, part.value]));
  const weekday = {Sun:0,Mon:1,Tue:2,Wed:3,Thu:4,Fri:5,Sat:6}[atlantaParts.weekday];
  const hour = Number(atlantaParts.hour);
  const minute = Number(atlantaParts.minute);
  // Monday 12:00 AM through Friday 11:59 PM Eastern.
  const ordersOpen = weekday >= 1 && weekday <= 5;
  const localToday = new Date(Date.UTC(Number(atlantaParts.year), Number(atlantaParts.month)-1, Number(atlantaParts.day), 12));
  const daysUntilSunday = (7 - weekday) % 7 || 7;
  localToday.setUTCDate(localToday.getUTCDate() + daysUntilSunday);
  const upcomingSunday = localToday.toISOString().slice(0, 10);
  [...select.options].forEach(option => {
    if (!option.value) return;
    if (!option.dataset.date) option.dataset.date = upcomingSunday;
    option.textContent = option.dataset.drop + ' · ' + option.dataset.location + ' · ' + option.dataset.date + ' · ' + option.dataset.window;
    const cutoff = (option.dataset.cutoff || '').trim();
    const parsedCutoff = cutoff ? new Date(cutoff) : null;
    if ((cutoff && (Number.isNaN(parsedCutoff.getTime()) || now >= parsedCutoff)) || !ordersOpen) option.remove();
  });
  function sync() {
    const selected = select.selectedOptions[0];
    const valid = Boolean(selected && selected.value);
    Object.entries(fields).forEach(([key, field]) => {
      field.disabled = !valid;
      field.value = valid ? selected.dataset[key] : '';
    });
    if (button && !button.dataset.originallyUnavailable) button.disabled = !valid;
    status.textContent = !ordersOpen ? 'Preorders are closed. Ordering opens Monday at 12:00 AM Eastern and closes Friday at 11:59 PM Eastern.' : (valid ? 'Sunday ' + selected.dataset.date + ' · Pickup anytime ' + selected.dataset.window + '.' : 'Select a pickup option before adding to bag.');
    addressDisplay.textContent = valid ? selected.dataset.address : '';
  }
  if (button && button.disabled) button.dataset.originallyUnavailable = 'true';
  select.disabled = false;
  select.innerHTML = select.options.length > 1 ? select.innerHTML.replace('Loading pickup options…', 'Select a pickup date and location') : '<option value="">' + (ordersOpen ? 'No pickup windows currently available' : 'Preorders closed — reopen Monday') + '</option>';
  if (!ordersOpen && button && !button.dataset.originallyUnavailable) button.textContent = 'Preorders Closed';
  sync();
  select.addEventListener('change', sync);
  form.addEventListener('submit', event => {
    if (!ordersOpen || !select.value) { event.preventDefault(); if (ordersOpen) select.reportValidity(); }
  });
});

// Storefront cart consistency guard. This is a customer-facing safeguard,
// not a checkout-level validation or a substitute for Shopify inventory.
document.addEventListener('DOMContentLoaded', () => {
  const picker = document.querySelector('[data-stickys-pickup]');
  if (!picker) return;
  const form = picker.closest('form');
  const select = picker.querySelector('#stickys-pickup-option');
  const warning = picker.querySelector('[data-cart-location-warning]');
  if (!form || !select || !warning) return;
  let pending = false;
  form.addEventListener('submit', async (event) => {
    if (pending || !select.value) return;
    event.preventDefault();
    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      const chosen = select.selectedOptions[0];
      const existing = (cart.items || []).filter(item => item.properties && item.properties['Pickup location']);
      const mixed = (cart.items || []).some(item => !item.properties || !item.properties['Pickup location']);
      const mismatch = existing.some(item => item.properties['Pickup location'] !== chosen.dataset.location || item.properties['Pickup date'] !== chosen.dataset.date);
      if (mixed || mismatch) {
        warning.hidden = false;
        warning.textContent = 'Your bag already contains items for a different pickup or purchase type. Please check out separately or empty your bag before changing pickup locations.';
        warning.scrollIntoView({behavior:'smooth',block:'center'});
        return;
      }
      warning.hidden = true;
      pending = true;
      form.requestSubmit();
    } catch (error) {
      warning.hidden = false;
      warning.textContent = 'We could not verify your bag. Please refresh and try again.';
    }
  });
});

// Header navigation toggle
document.addEventListener('DOMContentLoaded',function(){var btn=document.querySelector('[data-menu-toggle]');var nav=document.querySelector('[data-nav]');if(btn&&nav){btn.addEventListener('click',function(){var expanded=btn.getAttribute('aria-expanded')==='true';btn.setAttribute('aria-expanded',String(!expanded));nav.classList.toggle('is-open',!expanded);});}});


(function () {
  const path = window.location.pathname;

  if (
    path.startsWith('/collections/') ||
    path.startsWith('/products/')
  ) {
    try {
      sessionStorage.setItem(
        'stickys_last_shopping_page',
        window.location.href
      );
    } catch (error) {
      // Shopping continues normally
    }
  }
})();
